import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

type Props = {
  label?: string
  extraClass?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Label',
  props: {
    label: { default: '' },
    extraClass: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.label)
    ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass(`label ${_ctx.extraClass}`),
        "data-testid": "label"
      }, _toDisplayString(_ctx.label), 3 /* TEXT, CLASS */))
    : _createCommentVNode("v-if", true)
}
}

})